import React from 'react'
import {
  Container,
  Text,
  LeftDiv,
  RightDiv,
  BrandName
} from './IndicationBar.styles'
import { MiddleBorder } from '../../pages/Calculator/Calculator.styles'
import FeedbackButton from '../Feedback/FeedbackButton'

type IndicationBarProps = {
  brandName: string
  surveyQuestion: string
}

const IndicationBar: React.FC<IndicationBarProps> = ({
  brandName,
  surveyQuestion
}) => {
  return (
    <Container>
      <LeftDiv>
        <Text>Select Model(s) to add to calculator</Text>
      </LeftDiv>
      <MiddleBorder />
      <RightDiv>
        <Text>Selected Model(s)</Text>
        <FeedbackButton surveyQuestion={surveyQuestion} />
        <BrandName>{brandName}</BrandName>
      </RightDiv>
    </Container>
  )
}

export default IndicationBar
